import * as $http from 'axios'

export default {
    update: payload => $http.put('v2/user_personal_stories/update_story_manager', payload)
}
